export const login = "Therapist/UserLogin";
export const forgotPassword = "Common/ForgetPassword";
export const GetDiplomas = "Therapist/GetDiplomas";
export const GetStates = "Common/GetStates";
export const TherapistSignup = "Therapist/TherapistSignup";
export const PatientSignup = "Patient/PatinetSignupWeb";
export const GetDashboardCountsApi = "Therapist/GetDashboardCounts";
export const CheckLoginApi = "Therapist/CheckLogin";
export const GetTherapistProfileApi = "Therapist/GetTherapistProfile";
export const GetMyPatientsApi = "Therapist/GetMyPatients";
export const GetMyAppoinmentsApi = "Therapist/GetMyAppoinments";
export const GetAssesmentPdfApi = "Therapist/GetAssesmentPdf";
export const SavePatientRefuseAssessmentApi = "Therapist/SavePatientRefuseAssessment";
export const UpdateAppoinmentStatusApi = "Patient/UpdateAppoinmentStatus";
export const GetTherapistTimeSlotsApi = "Therapist/GetTherapistTimeSlots";
export const AdminSendEmailApi = "Admin/SendEmail";
export const SaveNotificationApi = "Therapist/SaveNotification";
export const UploadDocumentApi = "Therapist/UploadDocument";
export const GetPatientAssessmentsApi = "Patient/GetPatientAssessments";
export const GetPatientNoteApi = "Therapist/GetPatientNote";
export const SavePetientNoteApi = "Therapist/SavePetientNote";
export const GetVideosApi = "Therapist/GetVideos";
export const SaveShareVideosApi = "Therapist/SaveShareVideos";
export const PatientSendEmailApi = "Patient/SendEmail";
export const SaveAssessmentNotesApi = "Therapist/SaveAssessmentNotes";
export const PatientGetProfileApi = "Patient/GetProfile";
export const TP_GetPatientMedicalHistoryApi = "Patient/TP_GetPatientMedicalHistory";
export const TherapistGetSchedule = "Therapist/GetSchedule";
export const TherapistGetAppoinment = "Therapist/GetAppoinment";
export const TherapistGetTimeInterval = "Therapist/GetTimeInterval";
export const TherapistGetPopupdata = "Therapist/GetPopupdata";
export const TherapistSaveScheduleTime = "Therapist/SaveScheduleTime";
export const TherapistSaveAppoinment = "Therapist/SaveAppoinment";
export const PatientSaveAppoinment = "Patient/SaveAppoinment";
export const TherapistPatientCancelRefuseAssessment = "Therapist/PatientCancelRefuseAssessment";
export const TherapistRevertVPTCancelAssessment = "Therapist/RevertVPTCancelAssessment";
export const PatientPrescriptionGet = "patient/PatientPrescriptionGet";
export const TherapistPatientDischargeManage = "Therapist/PatientDischargeManage";
export const GetTimeZone = "Common/GetTimeZone";
export const TherapistSaveTherapistProfile = "Therapist/SaveTherapistProfile";
export const TherapistUpload = "Therapist/Upload";
export const AdminUpload = "Admin/Upload";
export const TherapistSaveSchedule = "Therapist/SaveSchedule";
export const AdminGetPatientHealthDetails = "Admin/GetPatientHealthDetails";
export const TherapistGetPatientOtherAssessment = "Therapist/GetPatientOtherAssessment";
export const TherapistGetPreviousAssessment = "Therapist/GetPreviousAssessment";
export const TherapistSavePatientOtherAssessment = "Therapist/SavePatientOtherAssessment";
export const TherapistGetAssessmentTemplates = "Therapist/GetAssessmentTemplates";
export const TherapistSaveAssessmentTemplate = "Therapist/SaveAssessmentTemplate";
export const TherapistGetPatientAssessment = "Therapist/GetPatientAssessment";
export const TherapistGetPatientRefuseAssessment = "Therapist/GetPatientRefuseAssessment";
export const TherapistGetPatientCervicalAssessment2 = "Therapist/GetPatientCervicalAssessment2";
export const TherapistGetPatientCervicalAssessment3 = "Therapist/GetPatientCervicalAssessment3";
export const TherapistGetPatientLowerAssessment3 = "Therapist/GetPatientLowerAssessment3";
export const PatientGetMedicalHistories = "Patient/GetMedicalHistories";
export const PatientGetPatientMedicalHistory = "Patient/GetPatientMedicalHistory";
export const TherapistGetPatientLumbarAssessment2 = "Therapist/GetPatientLumbarAssessment2";
export const TherapistGetPatientLumbarAssessment3 = "Therapist/GetPatientLumbarAssessment3";
export const AdminManageFile = "Admin/ManageFile";
export const AdminManagePatientNew = "Admin/ManagePatientNew";
export const AdminGetAppoinmentsStatus = "Admin/GetAppoinmentsStatus";
export const AdminGetQualityAnalysisReport = "Admin/GetQualityAnalysisReport";
export const AdminGetCAPrisonReport = "Admin/GetCAPrisonReport";
export const AdminGetDmeSurgicalAppoinments = "Admin/GetDmeSurgicalAppoinments";
export const AdminGetUserDetails = "Admin/GetUserDetails";
export const AdminGetAllTherapists = "Admin/GetAllTherapists";
export const AdminGetCompanies = "Admin/GetCompanies";
export const AdminGetPrisonSites = "Admin/GetPrisonSites";
export const AdminGetPrisonDiagnosisCodes = "Admin/GetPrisonDiagnosisCodes";
export const AdminSearchPatient = "Admin/SearchPatient";
export const AdminSaveInboxMessage = "Message/SaveInboxMessage";
export const TherapistGetPatientLowerAssessment2 = "Therapist/GetPatientLowerAssessment2";
export const TherapistGetPatientThoracicAssessment2 = "Therapist/GetPatientThoracicAssessment2";
export const TherapistGetPatientThoracicAssessment3 = "Therapist/GetPatientThoracicAssessment3";
export const TherapistGetPatientUpperAssessment2 = "Therapist/GetPatientUpperAssessment2";
export const TherapistGetPatientUpperAssessment3 = "Therapist/GetPatientUpperAssessment3";
export const TherapistGetPatientVestibularAssessment2 = "Therapist/GetPatientVestibularAssessment2";
export const TherapistGetPatientVestibularAssessment3 = "Therapist/GetPatientVestibularAssessment3";
export const TherapistGetPatientReAssessment = "Therapist/GetPatientReAssessment";
export const TherapistGetPatientReAssessment2 = "Therapist/GetPatientReAssessment2";
export const PatientGetAppoinments = "Patient/GetAppoinments";
export const TherapistGetSharedVideos = "Therapist/GetSharedVideos";
export const PatientSavePatientMedicalHistory = "Patient/SavePatientMedicalHistory";
export const PatientGetPatientAssessmentZoomDetailWeb = "Patient/GetPatientAssessmentZoomDetailWeb";
export const PatientGetTherapists = "patient/GetTherapists";
export const GetCompanies = "Patient/GetCompanies";
export const PatientGetCompaniesforPatient = "Patient/GetCompaniesforPatient";
export const PatientSaveAppoinmentNew = "Patient/SaveAppoinmentNew";
export const PatientRequestForAppoinment = "Patient/RequestForAppoinment";
export const AdminRegisterNurse = "Admin/RegisterNurse";
export const AdminGetDashBoardData = "Admin/GetDashBoardData";
export const AdminEnableDisableUser = "Admin/EnableDisableUser";
export const AdminOverrideUserNPI = "Admin/OverrideUserNPI";
export const AdminGetMyPatient = "Admin/GetMyPatient";
export const AdminGetMyPayments = "Admin/GetMyPayments";
export const AdminGetMarketingData = "Admin/GetMarketingData";
export const AdminAppRejUser = "Admin/Admin_AppRejUser";
export const AdminGetAppointments = "Admin/GetAppointments";
export const AdminGetAppointmentPays = "Admin/GetAppointmentPays";
export const AdminUpdateAppointmentPay = "Admin/UpdateAppointmentPay";
export const AdminGetAccountReceived = "Admin/GetAccountReceived";
export const AdminGetDischargeReport = "Admin/GetDischargeReport";
export const AdminGetFirstAppoinments = "Admin/GetFirstAppoinments";
export const AdminGetRequestsForAppointment = "Admin/GetRequestsForAppointment";
export const AdminGetPatientDischarge = "Admin/GetPatientDischarge";
export const AdminDownloadPatientDischarge = "Admin/DownloadPatientDischarge";
export const AdminGetPatientRefusal = "Admin/GetPatientRefusal";
export const AdminDownloadPatientRefusal = "Admin/DownloadPatientRefusal";
export const AdminGetUpdateUserFees = "Admin/GetUpdateUserFees";
export const AdminGetAccountReceivable = "Admin/GetAccountReceivable";
export const AdminGenerateInvoice = "Admin/GenerateInvoice";
export const AdminUpdateRequestStatus = "Admin/UpdateRequestStatus";
export const AdminGetTherapistAppoinments = "Admin/GetTherapistAppoinments";
export const AdminGetAllTherapist = "Admin/GetAllTherapist";
export const AdminUpdateAccountReceivable = "Admin/UpdateAccountReceivable";
export const AdminGetSelfPayAppointments = "Admin/GetSelfPayAppointments";
export const StripeCheckoutCreateIntent = "StripeCheckout/CreateIntent";
export const StripeCheckoutBookSelfPayAppointment = "StripeCheckout/BookSelfPayAppointment";
export const AdminUpdateTherapistFees = "Admin/UpdateTherapistFees";
export const SetPassword = "Common/ResetPassword";
export const UpdateRstPasswordink = "Common/UpdateRstPasswordink";
export const AdminSubmitClaimForm = "Admin/SubmitClaimForm";